function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18 15.73V11.9c0-.72-.4-1.28-.96-1.28H2.96c-.48 0-.96.56-.96 1.28v3.82c.08.71.48 1.27 1.03 1.27h14.01c.56 0 .96-.56.96-1.27zm-14.33-3.5h12.74v3.18H3.67v-3.19zm9.55-6.08a.5.5 0 01-.5.5h-1.88v1.89a.5.5 0 01-.5.5h-.6a.5.5 0 01-.5-.5V6.65H7.36a.5.5 0 01-.5-.5v-.59c0-.28.22-.5.5-.5h1.88V3.17c0-.27.23-.5.5-.5h.6c.27 0 .5.23.5.5v1.89h1.88c.28 0 .5.22.5.5v.6z"
});

function SvgAddLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLine);
export default __webpack_public_path__ + "static/media/add-line.bf7a3192.svg";
export { ForwardRef as ReactComponent };